import { IncludeType } from '../../../common';
import { ProductWithAttributes } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

/**
 * Fetches group attributes for a given group ID and locale.
 *
 * @param groupId - The ID of the group to fetch attributes for.
 * @param locale - The locale to use when fetching data.
 * @param includeType - Specifies the type of attributes to include (default is `IncludeType.Available`).
 * @returns A promise that resolves to the first `ProductWithAttributes` in the response, or `null` if none exist.
 */
export const getGroupAttributes = async (
  groupId: number,
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<ProductWithAttributes | null> => {
  try {
    const url = `/group/attributes?ids=${encodeURIComponent(groupId)}&include=${encodeURIComponent(includeType)}&marketLocale=${encodeURIComponent(locale)}`;
    const response = await productCatalogueHttp.get<ProductWithAttributes[]>(url);

    if (response?.data?.length) {
      return response.data[0];
    }

    return null;
  } catch (error) {
    console.error(`Failed to fetch group attributes for groupId: ${groupId}`, error);
    return null;
  }
};
